import { render, staticRenderFns } from "./Archivio.vue?vue&type=template&id=58447c49"
import script from "./Archivio.vue?vue&type=script&lang=js"
export * from "./Archivio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports